import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import ReactCountdownClock from 'react-countdown-clock';
import UserForm from '../containers/UserForm';

const styles = theme => ({
  root: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  paper: theme.mixins.gutters({
    minWidth: '450px',
    maxWidth: '450px',
    textAlign: 'center',
    paddingTop: 16,
    paddingBottom: 16,
  }),
});

export const User = ({
  classes,
  error,
  loading,
  invite,
  token,
  onComplete,
}) => (
  <div className={classes.root}>
    <Paper className={classes.paper} elevation={4}>
      {loading && <CircularProgress size={50} />}
      {!loading && (
        <div>
          {error && (
            <div>
              <Typography color="error">
                Sorry, an error has occurred: <u>{error}</u>.
              </Typography>
              <ReactCountdownClock
                seconds={15}
                size={50}
                weight={5}
                color="#044591"
                onComplete={onComplete}
              />
              <Typography variant="caption">
                You will be redirected shortly.
              </Typography>
            </div>
          )}
          {!error && <UserForm token={token} invite={invite} />}
        </div>
      )}
    </Paper>
  </div>
);

export default withStyles(styles)(User);
